import { Pedido, PEDIDO_STATUS } from '../types';

/**
 * Teto de receita bruta anual do MEI (Lei Complementar 123/2006, art. 18-A).
 * Valor vigente desde 2018; se o Congresso atualizar o teto, basta ajustar aqui.
 */
export const LIMITE_ANUAL_MEI = 81000;

/** Percentuais que disparam os avisos do marcador de limite (CONTEXT.md — persona Marcos). */
export const LIMITE_MEI_ATENCAO = 0.7;
export const LIMITE_MEI_ALERTA = 0.9;

type PedidoParaFaturamento = Pick<Pedido, 'data' | 'status' | 'valorTotal'>;

/**
 * Receita bruta acumulada no ano civil de `hoje`: soma do valor total dos pedidos
 * não cancelados emitidos no ano. Para o limite do MEI vale o faturamento
 * (vendas emitidas), não o que já foi recebido.
 */
export function faturamentoAnoAtual(
  pedidos: PedidoParaFaturamento[],
  hoje: Date = new Date()
): number {
  const ano = hoje.getFullYear();
  return pedidos.reduce((soma, pedido) => {
    // Orçamentos não são vendas — só contam para o limite depois de convertidos
    if (pedido.status === PEDIDO_STATUS.CANCELADO || pedido.status === PEDIDO_STATUS.ORCAMENTO)
      return soma;
    const dataPedido = new Date(pedido.data);
    if (Number.isNaN(dataPedido.getTime()) || dataPedido.getFullYear() !== ano) return soma;
    return soma + (pedido.valorTotal || 0);
  }, 0);
}
